import { render, staticRenderFns } from "./tender-all.vue?vue&type=template&id=c134a2ca&scoped=true"
import script from "./tender-all.vue?vue&type=script&lang=js"
export * from "./tender-all.vue?vue&type=script&lang=js"
import style0 from "./tender-all.vue?vue&type=style&index=0&id=c134a2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134a2ca",
  null
  
)

export default component.exports